import React from 'react';
import {Box, Button, Flex, useColorModeValue} from "@chakra-ui/react";

import { BiSolidReport } from "react-icons/bi";
import {BatteryComponent} from "./Charts/BatteryChart";
import {SolarComponent} from "./Charts/SolarChart";

const ResultsTab = ({setActiveTab}) => {
    const cardBg = useColorModeValue("gray.50", "gray.700");
    const cardShadow = useColorModeValue("md", "xl");

    return (
        <Box position="relative" height="100%" minW={"100%"} >
            <Box height="100%" minW="100%" overflowY={"auto"} >
                <Flex >
                    <Flex flex={"1"} direction={"column"}  gap={10}  >
                        <BatteryComponent height={"100%"} bg={cardBg} boxShadow={cardShadow} p={5} borderRadius="md"/>
                        <SolarComponent height={"100%"}  bg={cardBg} boxShadow={cardShadow} p={5} borderRadius="md"/>
                    </Flex>
                </Flex>
            </Box>

            <Button
                position="absolute"
                right={4}
                bottom={4}
                rightIcon={<BiSolidReport />}
                colorScheme="orange"
                isDisabled={false}
                onClick={()=>setActiveTab(3)}
            >
                Show Reports
            </Button>

        </Box>
    );
}

export default ResultsTab;
